import {
  Box,
  Button,
  Text,
  Heading,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalFooter,
  ModalBody,
  Image,
} from "@chakra-ui/react";
import successImage from "../../assets/images/success.jpg";
import { Translator } from "../Language";

const SuccessModal = ({ isOpen, onClose, title, text, titleTranslator }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="6xl"
      isCentered
      motionPreset="slideInBottom"
    >
      <ModalOverlay />
      <ModalContent
        w={["100%", "552px"]}
        p="0px"
        borderRadius={["12px", "20px"]}
        overflow="hidden"
      >
        <ModalBody p={["32px", "60px 40px 60px 40px"]}>
          <Box display={"flex"} flexDir="column" alignItems="center" gap="24px">
            <Image src={successImage} alt="success" w={["60px", "100px"]} />
            {title && (
              <Heading
                fontSize={["20px", "24px"]}
                lineHeight="33.6px"
                fontWeight="700"
                textAlign="center"
              >
                {title}
              </Heading>
            )}

            {titleTranslator && (
              <Heading
                fontSize={["20px", "24px"]}
                lineHeight="33.6px"
                fontWeight="700"
                textAlign="center"
              >
                <Translator path={titleTranslator} />
              </Heading>
            )}
            {text && (
              <Text color="#5C6066" lineHeight={"28px"} textAlign="center">
                {text}
              </Text>
            )}
          </Box>
        </ModalBody>
        <ModalFooter width="100%" p={0} height={["56px", "69px"]}>
          <Button
            width="100%"
            variant="primary"
            borderRadius={0}
            height={["56px", "69px"]}
            fontWeight={[600, 400]}
            onClick={onClose}
          >
            <Translator path="global.modal.close" />
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default SuccessModal;
